(function () {

	"use strict";

	var wrapper = document.getElementById("figures");
	var counters = document.getElementsByClassName("counter");
	var counter = [];
	var pageY = 0;

	function setCounter(elm) {

		// Get counter values (start, end and step)
		var val = parseFloat(elm.textContent);
		var nxt = parseFloat(elm.getAttribute("data-top"));
		var stp = parseFloat(elm.getAttribute("data-step")) || 1;

		// Init counter on element
		counter.push(new UnitCounter(elm, 2, val, nxt, stp));
	}

	function onWinScroll() {

		var position = window.pageYOffset + window.innerHeight;
		var threshold =  wrapper.offsetTop;
		var direction = window.pageYOffset - pageY;
		var is_positive, is_negative, value;

		if (counter.length === 0) {

			threshold += 64;

			if (position >= threshold && direction > 0) {

				Array.prototype.slice.call(counters).forEach(setCounter);
			}
		} else {

			threshold += (direction > 0) ? 64 : -64;

			is_positive = (position >= threshold && direction > 0);
			is_negative = (position < threshold && direction < 0);

			if (is_positive || is_negative) {

				counter.forEach(function (elm) {

					value = (is_positive) ? parseFloat(elm.elm[0].getAttribute("data-top")) : 0;

					if (elm.pos !== value) {

						elm.setVal(value);
					}
				});
			}
		}

		pageY = window.pageYOffset;
	}

	window.addEventListener("load", onWinScroll);
	window.addEventListener("scroll", onWinScroll);
}());
